import { render } from "./AvatarImage.vue?vue&type=template&id=294c155a"
import script from "./AvatarImage.vue?vue&type=script&lang=js"
export * from "./AvatarImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/elements/AvatarImage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "294c155a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('294c155a', __exports__)) {
    api.reload('294c155a', __exports__)
  }
  
  module.hot.accept("./AvatarImage.vue?vue&type=template&id=294c155a", () => {
    api.rerender('294c155a', render)
  })

}


export default __exports__